/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * How the target goal is determined for the challenge
 * @export
 */
export const TargetGoalMode = {
    ADMIN_SET: 'ADMIN_SET',
    PARTICIPANT_NEGOTIATED: 'PARTICIPANT_NEGOTIATED',
    TEMPLATE_DEFAULT: 'TEMPLATE_DEFAULT'
} as const;
export type TargetGoalMode = typeof TargetGoalMode[keyof typeof TargetGoalMode];


export function instanceOfTargetGoalMode(value: any): boolean {
    for (const key in TargetGoalMode) {
        if (Object.prototype.hasOwnProperty.call(TargetGoalMode, key)) {
            if (TargetGoalMode[key as keyof typeof TargetGoalMode] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TargetGoalModeFromJSON(json: any): TargetGoalMode {
    return TargetGoalModeFromJSONTyped(json, false);
}

export function TargetGoalModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): TargetGoalMode {
    return json as TargetGoalMode;
}

export function TargetGoalModeToJSON(value?: TargetGoalMode | null): any {
    return value as any;
}

export function TargetGoalModeToJSONTyped(value: any, ignoreDiscriminator: boolean): TargetGoalMode {
    return value as TargetGoalMode;
}

